var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 9.471 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-sweep",
    "data-name": "Icon material-delete-sweep",
    d: "M3.706,15.588A1.416,1.416,0,0,0,5.118,17H9.353a1.416,1.416,0,0,0,1.412-1.412V8.529H3.706Zm7.765-9.882H9.353L8.647,5H5.824l-.706.706H3V7.118h8.471Z",
    transform: "translate(-2.5 -4.5)",
    fill: "none",
    stroke: "#b8b8b8",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.6826e3d6.svg";
export { ForwardRef as ReactComponent };